import { render, staticRenderFns } from "./wallet-head.vue?vue&type=template&id=62525962&scoped=true"
import script from "./wallet-head.vue?vue&type=script&lang=js"
export * from "./wallet-head.vue?vue&type=script&lang=js"
import style0 from "./wallet-head.vue?vue&type=style&index=0&id=62525962&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62525962",
  null
  
)

export default component.exports